import component from '../component';

export default component('MuiFormControl', {
  defaultProps: {
    variant: 'standard',
    fullWidth: true,
  },
});
